import React, { useEffect, useState } from 'react';

import Grid from '@mui/material/Grid2';

import {
  Character,
  CharacterFeature,
  CharacterBonusSpells,
  Spell,
} from "@dndModels";
import { DisablableOption } from "@models";

import DataUtilities from '@dndUtilities/data_utilities';

import SelectStringBox from "@components/input/selects/SelectStringBox";
import LoadingBox from "@components/input/LoadingBox";
// import SelectSpellBox from '../../select/SelectSpellBox';

interface Props {
  character: Character;
  char_feature: CharacterFeature;
  given_id: string;
  onChange: (changed: CharacterBonusSpells) => void;
}

const data_util = DataUtilities.getInstance();

export default function CharacterBonusSpellInput({ 
  character,
  char_feature,
  given_id,
  onChange
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [ping, setPing] = useState(false);
  const [versions, setVersions] = useState<Spell[]>([]);
  const [options, setOptions] = useState<DisablableOption[]>([]);

  // eslint-disable-next-line
  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      const new_variants = data_util.getSpellVariants(given_id);
      setVersions(new_variants);
      setOptions(new_variants.map(spell => {
        const opt: DisablableOption = {
          id: spell._id, text: spell.true_name
        };
        return opt;
      }));
    }
  });

  if (!fetched) {
    return (<LoadingBox />);
  } else if (versions.length > 1) {
    const char_bs = char_feature.feature_options[0] as CharacterBonusSpells;
    // console.log(variants);
    const dominant_variant = versions.find(o => data_util.is_dominant(o));
    if (dominant_variant) {
      let selected_spell_id = char_bs.selected_spell_id_for_given_id[given_id];
      if (!selected_spell_id) {
        selected_spell_id = "";
      }
      return (
        <Grid
          size={{
            xs: 12
          }}>
          <SelectStringBox 
            name={ `Choose a Variant for ${dominant_variant.name}` }
            value={selected_spell_id} 
            options={options}
            onChange={(id: string) => {
              const changing = char_feature.feature_options[0] as CharacterBonusSpells;
              changing.selected_spell_id_for_given_id[given_id] = id;
              // char_feature.feature_options = [changing];
              onChange(changing);
              setPing(!ping);
            }} 
          />
        </Grid>
      );
    }
  }
  return <></>;
}
